import Component from '../abstracts/Component';
const {Crawler, middleware} = require('./../../../../node_modules/es6-crawler-detect/src')
import SimpleCarouselComponent from "./SimpleCarouselComponent";
/**
 Recommendation Engine Component
 */
export default class RecommendationEngineComponent extends Component {

  get COMPONENTNAME() {
    return 'RecommendationEngineComponent';
  }

  get SELECTORS() {
    return {
      recommendationProductsContainer: '[data-recommendation-engine-products-container]',
      recommendationProductsCarousel: '[data-recommendation-engine-products-carousel]',
    };
  }

  get CONSTANTS() {
    return {
      recommendationUrl: "/ajax/recommendation",
      get: "GET",
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.recommendationContainer = this.$component;
    this.recommendationProductsContainer = this.$component.querySelector(this.SELECTORS.recommendationProductsContainer);
    this.recommendationProductsCarousel = this.$component.querySelector(this.SELECTORS.recommendationProductsCarousel);
  }

  getMarketingOpts(recommendationComponent) {
    let opts = {};
    opts.webRecommendationHtmlData = true;
    opts.template = recommendationComponent.dataset.template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.saleMode = document.documentElement.dataset.salemode;
    return opts;
  }

  getSimilarOpts(recommendationComponent) {
    let opts = {};
    opts.similarHtmlData = true;
    opts.template = recommendationComponent.dataset.template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.saleMode = document.documentElement.dataset.salemode;
    return opts;
  }

  callServer(paramsObj, callBackOnSuccess, callBackOnFailure, timeoutTime) {
    let xhttp = new XMLHttpRequest();
    let params = new URLSearchParams();

    for(let key in paramsObj) {
      params.append(key, paramsObj[key]);
    }

    if(timeoutTime != null) {
      xhttp.timeout = timeoutTime;
    }

    xhttp.open(this.CONSTANTS.get, this.CONSTANTS.recommendationUrl + "?" + params.toString().replace(/\+/gi ,"%20"), true);

    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        callBackOnSuccess(this);
      }else{
        if (this.readyState === 4 && (this.status === 500 || this.status === 404)) {
          callBackOnFailure();
        }
      }
    };

    xhttp.ontimeout = function () {
      callBackOnFailure();
    };

    xhttp.onerror = function () {
      callBackOnFailure();
    };

    xhttp.send();
  }

  renderData(data) {
    if(data && data.responseText) {
      let recommendationProductsComponent = this.recommendationProductsContainer ;
      if(recommendationProductsComponent != null) {
        recommendationProductsComponent.innerHTML = data.responseText;
        let simpleCarousel = new SimpleCarouselComponent(this.recommendationProductsCarousel);
        simpleCarousel.initAsynchCarousel();
      }
    } else {
      this.hideComponent();
    }
  }

  tryAgain() {
    let recommendationComponent = this.recommendationContainer;
    this.callServer(this.getSimilarOpts(recommendationComponent), this.renderData.bind(this), this.hideComponent.bind(this), null);
  }

  hideComponent() {
    let recommendationComponent = this.recommendationContainer;
    if(recommendationComponent != null){
      recommendationComponent.innerHTML = "";
    }
  }

  setup (recommendationComponent) {
    let timeout = recommendationComponent.dataset.timeout;
    let template = recommendationComponent.dataset.template;
    let CrawlerDetector = new Crawler();
    let userAgentString = navigator.userAgent;

    if(!CrawlerDetector.isCrawler(userAgentString)) {
      this.callServer(this.getMarketingOpts(recommendationComponent), this.renderData.bind(this), template === "t-product" ? this.tryAgain.bind(this) : this.hideComponent.bind(this), timeout);
    }else{
      this.hideComponent();
    }
  }

  render() {
    this.log('Rendering...');
    // launch component
    if(this.recommendationContainer != null){
      this.setup(this.recommendationContainer);
    }
  }

}
